import { useState, useEffect } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import EventIcon from '@material-ui/icons/Event';
import HomePage from "../../Home"
import { Container } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { obtenerDevolucionesPendientesAction, obtenerDevolucionesPendientesVersionAction } from "../../../ducks/devolucionesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import TDevoluciones from "../TDevoluciones"
import useCatalogos from "../../../hooks/useCatalogos"

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
const VDevoluciones = () => {
    const [value, setValue] = useState(0)
    const catalogoVersion = useCatalogos("Package/Version")
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
    const handleClick = ({ version }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerDevolucionesPendientesVersionAction({version: version})).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Devoluciones</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="secondary">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                aria-label="scrollable force tabs example"
                            >
                                {
                                    catalogoVersion.map((version, index) =>
                                        <Tab
                                            key={version.IdCatVersionPaquete}
                                            label={`Pendientes ${version.Descripcion}`}
                                            icon={<EventIcon />}
                                            onClick={() => handleClick({ version: version.IdCatVersionPaquete })}
                                            {...a11yProps(index)}
                                        />
                                    )
                                }

                            </Tabs>
                        </AppBar>
                        {
                            catalogoVersion.map((version, index) =>
                                <TabPanel value={value} key={version.IdCatVersionPaquete} index={index}>
                                    <TDevoluciones />
                                </TabPanel>
                            )
                        }
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VDevoluciones